import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { XCircle } from 'lucide-react';

export default function CheckoutCancel() {
  const { t } = useI18n();
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 lg:py-32 text-center" data-testid="checkout-cancel-page">
      <XCircle size={64} className="text-[#a3b5ad] mx-auto mb-8" strokeWidth={1.2} />
      <h1 className="font-serif text-5xl text-[#f5f5f0] mb-4">{t('checkout.cancel_t')}</h1>
      <p className="text-lg text-[#a3b5ad] font-light mb-10">{t('checkout.cancel_b')}</p>
      <Link to="/catalog" className="gn-btn-primary">{t('checkout.back_catalog')}</Link>
    </div>
  );
}
